<script setup>
import Card from '@/components/Shared/Card.vue';
import FormEditor from "@/components/Shared/Form/Editor/Index.vue";
import {computed, ref, toRef} from "vue";
import {useForm} from "@inertiajs/vue3";
import {debounce} from "lodash";

const props = defineProps({
  id: {
    type: Number,
  },
  ticket_id: {
    type: Number,
  },
  user: {
    type: Object,
  },
  dateCreated: {
    type: String,
  },
  message: {
    type: String,
  },
  private: {
    type: Boolean,
    default: false,
  },
  isFromPartner: {
    type: Boolean,
    default: false,
  },
  isOriginalMessage: {
    type: Boolean,
    default: false,
  },
  isEditAble: {
    type: Boolean,
    default: false,
  },
  availableReplyIds: {
    type: Array,
  }
});

const replyForm = useForm({message: props.message})
const message = toRef(props, 'message');
const editor = ref()
const editMode = ref(false)
const findReplyReferencesRegex = ref(new RegExp(/!(\d+)([.,\s])/g));

const getIdentifier = computed(() => {
  return props.id ?? 0
})

const checkForLinkableReplies = debounce(() => {
  replyForm.message = replyForm.message.replace(findReplyReferencesRegex.value, function (matched, group1, group2) {
    if (props.availableReplyIds.includes(parseInt(group1))) {
      return `<a href="#${group1}">!${group1}</a>${group2}`
    }
    return matched
  }, 500)
})

function submit() {
  return axios
    .put(route('partner-support.tickets.edit-reply', {ticket: props.ticket_id, reply: props.id, ...replyForm}))
    .then(() => {
      toggleEditMode();
      editor.value.reset();
      message.value = replyForm.message
    }).catch((data) => {
      replyForm.errors = data.response.data;
    })
}

function toggleEditMode() {
  editMode.value = !editMode.value
}
</script>

<template>
  <card :class="{ 'private_note': private }">
    <template #header>
      <div class="d-flex justify-content-start align-items-center gap">
        <div class="text-muted">{{ getIdentifier }}</div>
        <div class="font-bold text-lg">{{ user?.name }}</div>
        <div class="text-muted font-medium">{{ moment(dateCreated).format('MMM DD, YYYY, h:mm:ss A') }}</div>
        <div class="ml-auto font-bold text-lg">
          <span v-if="isOriginalMessage">
            {{ trans('flows.Original message') }}
          </span>
          <span v-else-if="private"> {{
              trans('flows.Private note')
            }}
          </span>
          <div v-if="isEditAble && !$attrs.seenByUser && !private" style="margin-left: auto;">
            <button class="btn btn-outline-secondary" @click="toggleEditMode()">
              <svg class="icon" style="width: 20px; height: 20px">
                <use v-if="!editMode" xlink:href="#edit-icon"></use>
                <use v-else xlink:href="#eye-icon"></use>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </template>
    <template #body>
      <div v-if="!editMode" v-html="message"></div>
      <div v-else>
        <form-editor
          ref="editor"
          v-model="replyForm.message"
          :error="replyForm.errors?.message"
          style="background: white"
          :placeholder="trans('__JSON__.Reply here')"
          @update:modelValue="checkForLinkableReplies"
        ></form-editor>
        <div class="w-full justify-content-end flex my-2">
          <button class="btn btn-success" @click="submit()">{{ trans('edit') }}</button>
        </div>
      </div>
    </template>
  </card>
</template>

<style>
.private_note {
  background-color: #fff7d1;
}

.private_note div:first-child {
  background-color: #fff7d1;
}
</style>